import React from 'react';
import { createPortal } from 'react-dom';
import './SessionExpiredModal.scss';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onLogin: () => void;
  message?: string;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ 
  isOpen, 
  onLogin,
  message = "Your session has expired. Please log in again to continue."
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="session-expired-overlay">
      <div className="session-expired-modal">
        <div className="session-expired-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        <h2>Session Expired</h2>
        <p>{message}</p>
        <button 
          className="session-expired-login-button"
          onClick={onLogin}
        >
          Log In Again
        </button>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default SessionExpiredModal;
